interface Point {
    x: number;
    y: number;
}

interface Rectangle {
    left: number;
    top: number;
    right: number;
    bottom: number;
}

export function isPointInRect(
    { x, y }: Point,
    { left, top, right, bottom }: Rectangle
) {
    if (x >= left && x <= right && y >= top && y <= bottom) {
        return true;
    }

    return false;
}
